import ROUTES from 'routes';

export const logos = {
  adjust: require('assets/imgs/logos/adjust.png'),
  ali: require('assets/imgs/logos/ali.png'),
  appleSearchAds: require('assets/imgs/logos/appleSearchAds.svg'),
  applovin: require('assets/imgs/logos/applovin.png'),
  appsflyer: require('assets/imgs/logos/appsflyer.png'),
  badoo: require('assets/imgs/logos/badoo.svg'),
  eve: require('assets/imgs/logos/eve.svg'),
  fb: require('assets/imgs/logos/fb.svg'),
  google: require('assets/imgs/logos/google.png'),
  joom: require('assets/imgs/logos/joom.svg'),
  microsoftAd: require('assets/imgs/logos/microsoftAd.png'),
  prisma: require('assets/imgs/logos/prisma.svg'),
  raif: require('assets/imgs/logos/raif.svg'),
  reddit: require('assets/imgs/logos/reddit.svg'),
  sephora: require('assets/imgs/logos/sephora.svg'),
  tiktok: require('assets/imgs/logos/tiktok.png'),
  twitter: require('assets/imgs/logos/twitter.png'),
  unity: require('assets/imgs/logos/unity.png'),
  yahooJapan: require('assets/imgs/logos/yahooJapan.png'),
  uber: require('assets/imgs/logos/uber.svg'),
};

// `$logo` should be from `logos` variable above
// `$svg` should be from `assets/svg/*` cause its sprited

export default {
  title: 'OHM | Technology Digital Marketing Agency',
  description: 'Experience, technologies and digital marketing services to scale your business.',

  nav: [
    { name: 'Services', route: ROUTES.SERVICES },
    { name: 'Products', route: ROUTES.PRODUCTS },
    { name: 'Cases', route: ROUTES.CASES },
    { name: 'About us', route: ROUTES.ABOUT },
    { name: 'Careers', route: ROUTES.JOBS, external: true },
    { name: 'Blog', route: ROUTES.BLOG, external: true },
    { name: 'Get in touch', route: ROUTES.CONTACTS },
  ],

  socs: [
    { $svg: 'soc-tw', name: 'Twitter', url: 'https://twitter.com/ohmagencyglobal' },
    { $svg: 'soc-fb', name: 'Facebook', url: 'https://www.facebook.com/agency.ohm' },
  ],

  intro: [
    'Sell globally with our advanced marketing support',
    'We take business to a new level. Growing sales by more than 200%',
    'We think globally. We work all over the world and nurture expansion',
    'We run campaigns across all major advertising platforms',
    'We partner with Google for our marketing and analytics solutions',
    'Primary markets: USA, Canada, Australia, Spain, Germany, France, South Korea, UK, Japan, Italy',
    'Google Ads, Google Marketing Platform, Facebook Ads, Apple Search Ads, TikTok Ads, Microsoft Advertising, Twitter, Snapchat, Reddit, Yahoo Japan, Xiaomi Ads, Huawei Ads',
  ],

  services: {
    header: 'We help businesses to grow',
    list: [
      {
        $logo: 'raif',
        url: '#url',
        text2: '<span>x12</span> Digital Sales in 3 years',
        text: 'We used a lot of features and new technology that became public with the help of the Google Team',
      },
      {
        $logo: 'sephora',
        url: '#url',
        text2: '<span>x3,7</span> Mobile sales in 3 years',
        text: 'We brought the brand to a new market and supervised the company\'s activities in terms of mobile applications',
      },
      {
        $logo: 'eve',
        url: '#url',
        text2: '<span>x5</span> New players in 6 months',
        text: 'Learned how to work with post-view registrations (30% of the entire advertising campaign)',
      },
    ],
  },

  achs: {
    header: 'Our achievements',
    list: [
      {
        txt: 'Google Marketing Platform Certified Partner',
        img: require('assets/imgs/achs/gmp.png'),
      },
      {
        txt: 'Google Premier Partner',
        img: require('assets/imgs/achs/gPartner.png'),
      },
      {
        txt: 'Google Acceleration Partner',
        img: require('assets/imgs/achs/gap.png'),
      },
      {
        txt: 'Finalists in the App Excellence',
        img: require('assets/imgs/achs/gppa.png'),
      },
      {
        txt: 'Google Analytics Partner',
        img: require('assets/imgs/achs/gAnalytics.png'),
      },
      {
        txt: 'Facebook Supported Agency',
        img: require('assets/imgs/achs/fb.png'),
        // $svg: 'soc-fb',
      },
    ],
  },

  products: {
    header: 'Our Products',
    list: [
      {
        logo: require('assets/imgs/logos/ohm-query.svg'),
        name: 'query',
        url: 'https://query.video',
        desc: [
          'Personalised YouTube advertising based on search queries',
          'The optimal solution for large marketplaces',
        ],
      },
      {
        logo: require('assets/imgs/logos/ohm-smalldata.svg'),
        name: 'smalldata',
        url: 'https://smalldata.online',
        desc: 'Mobile marketing solution. All major advertising systems on one interface',
      },
      {
        logo: require('assets/imgs/logos/ohm-influmtr.svg'),
        name: 'influmtr',
        url: 'https://influmtr.com',
        desc: [
          'Smart ratings on the effectiveness of YouTube vloggers',
          'Influencer search tool',
        ],
      },
    ],
  },

  clients: {
    header: 'Our Clients',
    text: 'Leaders in e-commerce, finance, retail, FMCG and gaming trust us and grow their businesses with us',
    list: [ // item[0] from logos keys
      { $logo: 'prisma' },
      { $logo: 'eve' },
      { $logo: 'raif' },
      { $logo: 'uber' },
      { $logo: 'sephora' },
      { $logo: 'joom' },
      { $logo: 'ali' },
      { $logo: 'badoo' },
    ],
    header2: 'Our partners',
    text2: 'We partner with global leaders in the technology market and in digital advertising and marketing',
    list2: [ // item[0] from logos keys
      { $logo: 'google' },
      { $logo: 'fb' },
      { $logo: 'tiktok' },
      { $logo: 'twitter' },
      { $logo: 'reddit' },
      { $logo: 'yahooJapan' },
      { $logo: 'adjust' },
      { $logo: 'applovin' },
      { $logo: 'appleSearchAds' },
      { $logo: 'microsoftAd' },
      { $logo: 'unity' },
      { $logo: 'appsflyer' },
    ],
  },

  cases: {
    header: 'Our Cases',
    list: [
      {
        $company: 'raif',
        name: 'Raiffeisen Bank',
        desc: 'Increased knowledge about the 110 Day credit card',
        list: [
          {
            header: 'Goals',
            content: [
              'To increase knowledge about the 110 Day credit card',
              'To increase the influx of clients passing the bank’s credit score',
              'To stimulate sales',
            ],
          },
          {
            header: 'Approach',
            content: [
              'A three-step ad display system',
              'Concurrent use of the TrueView for Reach and TrueView for Action formats.',
              'Buying ads through the Google Marketing Platform',
            ],
          },
          {
            header: 'Results',
            content: [
              '<b>78% increase</b> in the recognition of its “110 days without interest” credit card',
              '<b>26% increase</b> in willingness to choose the card',
            ],
          },
          {
            content: [
              '<b>100% increase</b> in online sales of the card and',
              '<b>240% increase</b> in sales through performance channels',
            ],
          },
          {
            content: [
              '<b>18% increase</b> in the share of approved requests among new Raiffeisenbank customers',
            ],
          },
        ],
      },

      {
        $company: 'joom',
        name: 'Joom',
        desc: 'Improved all metrics with DV360 app re-engagement campaigns',
        list: [
          {
            header: 'Technology',
            content: [
              'Display and Video 360 were added to increase mobile app inventory',
              'Set up Campaign Manager 360 and integrate with the mobile tracker',
              'The mobile platform OHM Smalldata was used to dynamically exclude previously purchased users from targeting',
            ],
          },
          {
            header: 'Results',
            content: [
              'x6.4 in Impressions',
              'x9.4 in Revenue',
              'x4.3 in ROAS',
            ],
          },

        ],
      },

      {
        $company: 'eve',
        name: 'EVE Online (CCP Games)',
        list: [
          {
            header: 'Technology',
            content: [
              'Launched campaigns to attract new users on the DV360 platform with advertising on YouTube',
              'Optimised all ads for post-click and post-view conversions throughout the funnel of in-game events',
            ],
          },
          {
            header: 'Results',
            content: [
              'Post-view conversions  accounted for about 30% of the total volume',
              'We were able to set up post-click events from the game for search ads from Yahoo Japan and Bing by integrating them with CM360',
              'The technology for tracking post view conversions has the potential to be relevant for other game dev companies',
            ],
          },
        ],
      },
    ],
  },

  about: {
    header: 'About us',
    // achvs: [
    //   'Google Premier Partner',
    //   'Google Acceleration Partner',
    //   'Google Marketing Platform Certified Partner',
    //   'Facebook Supported Agency',
    // ],
    list: [
      {
        header: 'Main competencies',
        contents: [
          [
            'Developing clients\' business',
            'Introducing products onto new markets. In the modern world, it\'s really important to be able to create regional campaigns quickly and efficiently, without wasting your team\'s resources.',
          ],
          // 'If you are interested in a specific country, write to us and we\'ll research the market and draw up a proposal.',
        ],
      },

      {
        header: 'Effectiveness',
        contents: [
          'There are two criteria that make for an effective advertising campaign:',
          [
            'The campaign should achieve the target objectives;',
            'The client\'s costs for achieving these results should be as low as possible.',
          ],
          // 'That\'s why we not only plan our advertising campaigns thoroughly, but we also analyze the results in real time, and, if necessary, we make adjustments to the interactions in order to achieve the best results.',
        ],
      },
    ],
  },

  team: {
    header: 'Team',
    contents: [
      'The OHM team is made up of professionals with experience in digital marketing, advertising, analytics and PR. We know how to promote projects in the field of e-commerce, finance, gaming and FMCG.',
      'We value complex tasks, individual approach and long-term cooperation with clients. Our expertise allows us to make use of the best global technologies and local practices, and also to adapt these according to our clients\' objectives.',
    ],
    people: [
      {
        $id: 'romaOsokin',
        name: 'Roma Osokin',
        title: 'CEO',
      },
      {
        $id: 'mayyaKim',
        name: 'Mayya Kim',
        title: 'Clients Support Lead',
      },
      {
        $id: 'klimChe',
        name: 'Klim Che',
        title: 'AdTech Products Lead',
      },
      {
        $id: 'polinaPavlova',
        name: 'Polina Pavlova',
        title: 'Clients Development Director',
      },
      {
        $id: 'arinaLyakh',
        name: 'Arina Lyakh',
        title: 'Digital Marketing Lead',
      },
      {
        $id: 'andrewButko',
        name: 'Andrew Butko',
        title: 'Influencers Marketing Lead',
      },
    ],
  },

  areasOfWork: {
    header: 'Our Services',
    thead: ['Marketing Efficiency', 'Reach', 'Re-engagement', 'Acquisition', 'Sales / Revenue growth'],
    header2: 'Tools',
    list: [
      {
        header: 'Performance Marketing',
        text: 'We work towards concrete goals in terms of leads, sales and ROI. Paid Search, Paid Social, Video, Display and Shopping ads work for the result.',
        extLink: '/services/performancemarketing',
      },
      {
        header: 'GMP',
        text: 'We are Certified Partner. GMP helps advertisers around the world to effectively manage video, display and search advertising.',
        extLink: '/services/gmp',
      },
      {
        header: 'Mobile Acquisition',
        text: 'We achieve maximum efficiency through an integrated approach to the selection and testing of audiences and creatives.',
        extLink: '/services/appacquisition',
      },
      {
        header: 'Mobile Remarketing',
        text: 'We increase sales among different segments: new, active and dormant users. Use incrementality testing to estimate the impact of campaigns.',
        extLink: '/services/appremarketing',
      },
      {
        header: 'Video ads',
        text: 'Cross-platform campaigns: we help you to count conversions on web and app simultaneously. Reach or ROAS optimization.',
        extLink: '/services/video',
      },
    ],
  },

  contacts: {
    header: 'Feel free to contact us',
    consent: `By ticking this box I agree that I have read and accept the <a href="${ ROUTES.PRIVACY }" target="_blank">Privacy Policy</a> and consent to the given information being used by OHM to contact me.`,
    submit: 'Send',
    ps: 'Or send a message about what you’re looking for to <a href="mailto:welcome@ohm.agency?subject=Hi there!">welcome@ohm.agency</a>',
    addrs: [
      {
        $code: 'nl',
        country: 'The Netherlands',
        city: 'Amsterdam',
        text: 'Kingsfordweg 151,\n1043 GR,\nAmsterdam,\nThe Netherlands\n',
      },
      {
        $code: 'au',
        country: 'Australia',
        city: 'Sydney',
        text: '81-83 Campbell Street,\nSurry Hills,\nNSW 2010,\nAustralia\n',
      },
      {
        $code: 'cy',
        country: 'Cyprus',
        city: 'Limassol',
        text: 'Gregoriou Xenopoulou 30,\n3106,\nLimassol,\nCyprus\n',
      },
    ],
  },

  gmp: {
    intro: {
      header: 'Google Marketing Platform',
      content: 'The enigmatic Google Marketing Platform (GMP), formerly known as Doubleclick. It boasts solutions such as DV360 and Campaign Manager (among others), but not everyone knows its true significance, or for whom it can be useful. Let’s find out',
      img: require('assets/imgs/gmp/gmp-intro.png'),
    },

    cm: {
      header: 'Campaign Manager 360 (CM360)',
      content: {
        header: 'One of the best tools for analyzing ad traffic, evaluating the effectiveness of campaigns, creatives, user behavior, and much more. Here are 3 main tasks that the product can achieve: ',
        list: [
          '<b>1.</b>  Evaluating the effectiveness of advertising campaigns and creatives (post-view and post-click), user behavior after viewing ads on websites and apps, and which campaign chains lead to the best results.',
          '<b>2.</b>  Assessing unique reach (across all devices and from all advertising activities) and calculating cross-device conversions (when they have seen it on one device and made the conversion on another).',
          '<b>3.</b>  Optimizing creatives (which banner is best shown to whom), building chains of creatives and efficient distribution of traffic between devices.',
        ],
      },

      logo: require('assets/imgs/gmp/cm.svg'),
    },

    dv: {
      header: 'Display&Video 360 (DV360)',
      content: {
        header: 'The place where all video, media, and audio ads live. The only tool in the world with access to YouTube Ads automation. Here the networks of Google and all major media companies are brought together. ',
        list: [
          '<b>1.</b> Video: allows you to effectively manage advertising on YouTube and gives you access to almost all of the video sites in the world, in one place.',
          '<b>2.</b> Display and audio advertising: in one place, you can buy ads from the largest media networks, using all modern formats. But more importantly, DV360 allows you to efficiently purchase the largest volume of users at the lowest price, with control over the real frequency of impressions and, together with CM360, you can control the quality of impressions and optimize post-view and post-click conversions on all sites and apps.',
          '<b>3.</b> Data: DV360 integrates world-leading user-data providers, which allows you to deliver ads to a wide variety of audiences, based on their preferences, purchases, interests, and other data.',
        ],
      },
      logo: require('assets/imgs/gmp/dv.svg'),
    },

    searchAds: {
      header: 'Search Ads 360',
      content: 'Advanced automation and optimization of Google Ads search, as well as management of other search engines, in one place: Bing, Baidu, Yahoo Japan. It integrates data with CM360 to evaluate the effectiveness of video and display advertising on a search, and builds various attribution and optimization models.',
      img: require('assets/imgs/gmp/gmp-searchAds.png'),
      logo: require('assets/imgs/gmp/searchAds.svg'),
    },

    studio: {
      header: 'Studio',
      content: 'Allows you to create beautiful, complex, dynamic creatives, personalized formats and dynamic remarketing. A complementary solution for CM360 and DV360.',
      img: require('assets/imgs/gmp/gmp-studio.png'),
      logo: require('assets/imgs/gmp/studio.svg'),
    },

    gAnalytics: {
      header: 'Google Analytics 360',
      content: 'A paid version of the familiar GA. Essential for projects with heavy traffic, it gives access to “raw data”, generates a report without sampling, includes a Data-Driven attribution model, and integrates data about user impressions from CM/DV360.',
      img: require('assets/imgs/gmp/gmp-gAnalytics.png'),
      logo: require('assets/imgs/gmp/gAnalytics.svg'),
    },

    optimize: {
      header: 'Optimize 360',
      content: [
        'An advanced version of Basic Optimize. It allows you to conduct more tests (in greater detail) to increase conversion on the website and landing pages.',
        'GMP (Ex-Doubleclick) is great for anyone who actively uses video and display advertising in their work and wants to increase transparency, efficiency and, more importantly, to significantly expand the inventory, formats and audiences available to them. ',
      ],
      logo: require('assets/imgs/gmp/optimize.svg'),
      img: require('assets/imgs/gmp/gmp-optimize.png'),
    },

    cases: {
      header: 'Our Cases',
    },
  },

  'privacy.contest.use_cookie': 'We use cookies to ensure that we give you the best experience on our website.',
  'privacy.contest.learn_more': 'To learn more, see our',
  'privacy.contest.policy': 'Privacy Policy',
  'privacy.contest.accept': 'Accept',
  'privacy.contest.settings': 'Cookie Settings',

  'privacy.modal.h1': 'Cookie settings',
  'privacy.modal.necessary': 'Some cookies are required to provide core functionality.<br>The website won\'t function properly without these cookies and they are enabled by default and cannot be disabled.',
  'privacy.modal.analytical': 'Analytical cookies help us improve our website by collecting and reporting information on its usage.',
  'privacy.modal.marketing': 'Marketing cookies are used to track visitors across websites to allow publishers to display relevant and engaging advertisement',
  'privacy.modal.to_policy': 'Privacy Policy',
  'privacy.modal.submit.done': 'Done!',
  'privacy.modal.submit.save': 'Save Settings',
};
